import { lang } from '@umu/ukit-lang';
/**
 * @description
 */

import React, { Component } from 'react';
import {
    IMicrocourseDraftCommentInfo,
    IMicrocourseAudioImgArrItem,
    IComment,
    IMicrocourseDraftCommentExtendItem,
    UnknownObj,
} from '@umu/umu-types';

import { $window } from '@umu/umu-dom';
import { components, services } from 'common';
const { Toast } = services;
const {
    Dialog,
    DialogBody,
    DialogFooter,
    DialogFooterButton,
    DialogHeader,
    If,
    ToggleLine,
    MCheckbox,
    Textarea,
    Emg,
    Portal,
} = components;

import * as ImageUtil from '@umu/umu-image-handle';
import { copyObj, isEmptyObject, Deferred, safetyHtml, classMapSet, isSameObj } from '@umu/umu-util';
import wechatServiceAccount from '../../services/@wechatServiceAccount/wechatServiceAccount';
import commentUtil from './commentUtil';
import ConfigurableHeader from '../@configurableHeader/configurableHeader';
import PagePanel from '../@pagePanel/pagePanel';
import { postThrottle } from '../../@utils/umuUtil';
import './microCourseNoteComposer.scss';

let noteData: IMicrocourseDraftCommentInfo; // 缓存数据，如果没变则不重复提交
let picNoCheckConfirmDefer: Deferred;

export interface ISubmitData {
    note_state: number;
    name?: string;
    comment: string;
    comment_id?: string;
    extend_comment: string;
}

// tslint:disable-next-line:no-empty-interface
export interface IDraftCommentInfo extends IMicrocourseDraftCommentInfo {}

export interface IProps {
    showNoteComposer: boolean;
    imgArr: IMicrocourseAudioImgArrItem[];
    draftCommentInfo: IMicrocourseDraftCommentInfo;
    submitCommentSuccess(commentInfo: IComment, canShare: boolean): void;
}

export interface IState {
    showPicNoCheckConfirm: boolean;
    isShowPicNoteContentInput: boolean;
    picNoteContentIndex: number;
    picNoteContentImg: string;
    picNoteEditContent: string;
    comment: string;
    extendComment: IMicrocourseDraftCommentExtendItem[];
    commentPosting: boolean;
    rightClsName: string;
    isEditting: boolean;
    isDraftSaving: boolean; // 保存草稿？
}

class MicroCourseNoteComposer<IP extends IProps, IS extends IState> extends Component<IP, IS> {
    public resetTimeout: number = 0;
    public textareaPlaceholder = lang(
        '此处点击添加纯文字笔记；\n下方为老师课件图片，点选将图片加入笔记，图文结合让笔记更丰富，记忆更深刻！',
    );
    public picNotePlaceholder = lang('点击添加图文笔记..._1');

    public title: string = lang('记笔记');
    public leftTitle: string = lang('返回_BACK');
    public rightTitle: string = lang('提交_POST');

    constructor(props: IP) {
        super(props);

        this.onSaveFail = this.onSaveFail.bind(this);
        this.onSaveSuccess = this.onSaveSuccess.bind(this);

        this.onBack = this.onBack.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.saveNote = this.saveNote.bind(this);
        this.onNoteItemCheckChange = this.onNoteItemCheckChange.bind(this);
        this.completePicNoteContentEdit = this.completePicNoteContentEdit.bind(this);
        this.closePicNoteContentInput = this.closePicNoteContentInput.bind(this);
        this.onTextNoteInputChange = this.onTextNoteInputChange.bind(this);
        this.onTextNoteInputBlur = this.onTextNoteInputBlur.bind(this);
        this.closePicNoCheckConfirm = this.closePicNoCheckConfirm.bind(this);
        this.confirmPicNoCheckConfirm = this.confirmPicNoCheckConfirm.bind(this);
        this.resetCommentButton = this.resetCommentButton.bind(this);
        this.picNoteEditContentChange = this.picNoteEditContentChange.bind(this);

        this.initState(props);
    }

    public UNSAFE_componentWillReceiveProps(nextProps: IP) {
        let rightClsName = '';

        if (commentUtil.weikeCommentValidate(nextProps.draftCommentInfo)) {
            rightClsName = 'btn-link';
        }
        this.onDraftCommentInfoUpdate(nextProps);

        this.setState({
            rightClsName,
        });
    }

    public initState(props: IProps) {
        const draftCommentInfo: IMicrocourseDraftCommentInfo = copyObj(
            (props.draftCommentInfo as unknown as UnknownObj) || {},
        );
        let extendComment = draftCommentInfo.extend_comment || [];
        if (isEmptyObject(extendComment as unknown as UnknownObj)) {
            const initExtendComment = this.initalExtendContent();
            extendComment = initExtendComment;
        }

        // initExtendComment.forEach((item, idx) => {
        //     const exist = extendComment.find((_) => (_.index + '') === (idx + ''));
        //     // 第一次进入编辑状态，没有数据的从 init 里恢复
        //     if (!exist) {
        //         extendComment.push(item);
        //     } else if (typeof exist.is_selected === 'undefined') {
        //         // 排除已经设置过的
        //         exist.is_selected = 1;
        //         exist.picture_url = (exist as any).imageUrl;
        //     }
        // });

        noteData = copyObj((props.draftCommentInfo as unknown as UnknownObj) || {});

        this.state = {
            comment: draftCommentInfo.comment || '',
            extendComment,
            isShowPicNoteContentInput: false,
            showPicNoCheckConfirm: false,
            isEditting: !!draftCommentInfo.is_editting,
            isDraftSaving: false,
            commentPosting: false,
        } as IS;
    }

    public initalExtendContent() {
        const props = this.props;
        let imgArr = props.imgArr;
        imgArr = imgArr || [];
        const extendComment: IMicrocourseDraftCommentExtendItem[] = [];

        for (let i = 0; i < imgArr.length; i++) {
            const extendCommentItem = {} as IMicrocourseDraftCommentExtendItem;
            extendCommentItem.index = i;
            extendCommentItem.comment = '';
            extendCommentItem.is_selected = 0;
            extendCommentItem.picture_url = imgArr[i].imageUrl;
            extendComment.push(extendCommentItem);
        }
        return extendComment;
    }

    public onDraftCommentInfoUpdate(props: IProps) {
        if (
            isSameObj(
                props.draftCommentInfo as unknown as UnknownObj,
                this.props.draftCommentInfo as unknown as UnknownObj,
            )
        ) {
            return;
        }
        const draftCommentInfo: IMicrocourseDraftCommentInfo = copyObj(
            (props.draftCommentInfo as unknown as UnknownObj) || {},
        );
        const extendComment = draftCommentInfo.extend_comment || [];
        const initExtendComment = this.initalExtendContent();
        initExtendComment.forEach((item, idx) => {
            const exist = extendComment.find((_) => _.index + '' === idx + '');
            // 进入编辑状态，没有数据的从 init 里恢复
            if (!exist) {
                extendComment.push(item);
            }
        });

        noteData = copyObj((props.draftCommentInfo as unknown as UnknownObj) || {});

        this.setState({
            comment: draftCommentInfo.comment || '',
            extendComment,
            isEditting: !!draftCommentInfo.is_editting,
        });
    }

    public onSaveSuccess(commentInfo: IComment) {
        this.toggleCommentPosting(false);

        // 如果是保存草稿，什么也不做
        if (this.state.isDraftSaving) {
            return;
        }

        // 如果笔记中只有图片的话则不请求图片了，直接回到到原session 页面
        const isCommentHasWords = commentUtil.isCommentHasWords(noteData || ({} as IMicrocourseDraftCommentInfo));

        // 微信公众号关注逻辑 duanjun
        if (wechatServiceAccount.checkFollowUmu()) {
            let submitSuccessText = lang('提交成功');
            // 产品需求中去除分享引导 @2019-10-24 from xucan
            if (false && isCommentHasWords) {
                submitSuccessText = lang('提交成功，快去分享吧');
            }
            // 放到下一个事件循环
            setTimeout(() => {
                Toast.show({
                    message: submitSuccessText,
                });
            }, 0);
        } else {
            wechatServiceAccount.commit();
        }

        this.resetDraftContent();
        this.resetCommentButton();
        this.props.submitCommentSuccess(commentInfo, isCommentHasWords);
    }

    public onSaveFail() {
        this.toggleCommentPosting(false);
    }

    public onBack() {
        if (this.state.isEditting) {
            this.resetDraftContent();
            return;
        }
        this.setState({ isDraftSaving: true }, this.saveNote);
    }

    public onSubmit() {
        this.setState({ isDraftSaving: false }, this.saveNote);
    }

    public submitComment(data: ISubmitData) {
        console.warn('override me', data, this.onSaveSuccess, this.onSaveFail);
    }

    public syncCommentData(data: IDraftCommentInfo) {
        console.warn('override me', data);
    }

    // 笔记创建区
    public renderNoteContent() {
        return (
            <div className="weike-note-composer">
                <If condition={!this.state.isShowPicNoteContentInput}>
                    <div className="note-panel-dashboard">
                        <div className="text-note">{this.renderTextNoteInput()}</div>
                        <div className="pic-note">{this.renderPicNoteDashboard()}</div>
                    </div>
                </If>
                <If condition={this.state.isShowPicNoteContentInput}>
                    <div className="pic-note-text">{this.renderPicNoteContentInput()}</div>
                </If>
            </div>
        );
    }

    // -------notecomposer
    public saveNote() {
        const props = this.props;
        const self = this;
        if (this.state.commentPosting) {
            return;
        }

        // 如果是保存草稿，内容没有变化的话，不再次保存
        if (this.state.isDraftSaving) {
            if (JSON.stringify(noteData) === JSON.stringify(props.draftCommentInfo)) {
                return;
            }
        }

        // 缓存新数据至本地
        noteData = copyObj(props.draftCommentInfo as unknown as UnknownObj);

        if (!this.state.isDraftSaving && !commentUtil.weikeCommentValidate(noteData)) {
            Toast.show({
                message: lang('笔记内容为空，不能提交'),
            });
            return;
        }

        if (!postThrottle(JSON.stringify(noteData))) {
            return;
        }

        // 如果有写了笔记未勾选的图片，提示之
        if (!this.state.isDraftSaving && commentUtil.isPictureWithWordNotChecked(noteData)) {
            const continueThough = this.picNoCheckConfirm();
            continueThough.then(() => {
                // 继续
                self.doSaveNote();
            });
        } else {
            this.doSaveNote();
        }
    }

    // 保存笔记到服务器
    public doSaveNote() {
        // 如果是发布，则需要把未勾选的数据过滤掉
        const extendComment = this.state.isDraftSaving
            ? noteData.extend_comment
            : commentUtil.filterCheckedExtendComment(noteData.extend_comment);

        const data: ISubmitData = {
            note_state: this.state.isDraftSaving ? 0 : 1, // 0、保存草稿 1、发布
            name: '', // 暂时置空
            comment: noteData.comment,
            extend_comment: JSON.stringify(extendComment || []),
        };

        if (noteData.comment_id) {
            Object.assign(data, {
                comment_id: noteData.comment_id,
            });
        }

        this.toggleCommentPosting(true);

        this.submitComment(data);

        // 断网保护
        this.resetTimeout = $window.setTimeout(this.resetCommentButton, 30 * 1000);
    }

    public picNoCheckConfirm() {
        picNoCheckConfirmDefer = new Deferred();
        this.setState({
            showPicNoCheckConfirm: true,
        });
        return picNoCheckConfirmDefer.promise;
    }

    public resetDraftContent() {
        noteData = {
            comment: '',
            extend_comment: [],
        } as IMicrocourseDraftCommentInfo;

        // 既然下面会更新 props 了，而且 WillReceiveProps 里也会根据 nextProps 更新 state，为什么这里还要更新 state??
        // this.setState({
        //     comment: '',
        //     extendComment: this.initalExtendContent(),
        // });
        this.syncCommentData(copyObj(noteData as unknown as UnknownObj));
    }

    public resetCommentButton() {
        this.toggleCommentPosting(false);
        clearTimeout(this.resetTimeout);
    }

    public toggleCommentPosting(processing: boolean) {
        this.setState({
            commentPosting: processing,
        });
        if (processing) {
            Toast.show({
                message: this.state.isDraftSaving ? lang('草稿保存中...') : lang('提交中...'),
            });
        }
    }

    public closePicNoCheckConfirm() {
        this.setState({
            showPicNoCheckConfirm: false,
        });
        picNoCheckConfirmDefer.reject();
    }

    public confirmPicNoCheckConfirm() {
        this.setState({
            showPicNoCheckConfirm: false,
        });
        picNoCheckConfirmDefer.resolve();
    }

    public renderPicNoCheckConfirm() {
        return (
            <Dialog
                show={this.state.showPicNoCheckConfirm}
                hasMask={true}
                className="pic-not-check-confirm"
                canClose={true}
                close={this.closePicNoCheckConfirm}
                width="300"
            >
                <DialogHeader>
                    <div className="title">{lang('提示')}</div>
                </DialogHeader>
                <DialogBody>
                    <div className="info">
                        {lang('提交后，未勾选的图片对应文字笔记将丢失。若需保留文字，请输入到上方纯文字输入框内。')}
                    </div>
                </DialogBody>
                <DialogFooter>
                    <DialogFooterButton onClick={this.closePicNoCheckConfirm}>{lang('去修改')}</DialogFooterButton>
                    <DialogFooterButton onClick={this.confirmPicNoCheckConfirm}>{lang('确认提交')}</DialogFooterButton>
                </DialogFooter>
            </Dialog>
        );
    }

    public onNoteItemCheckChange(index: number, isChecked: boolean) {
        const extendComment = this.state.extendComment;
        extendComment[index].is_selected = isChecked ? 1 : 0;
        this.setState({
            extendComment,
        });
        this.syncCommentData({
            comment_id: this.props.draftCommentInfo.comment_id,
            comment: this.state.comment,
            extend_comment: extendComment,
            is_editting: this.state.isEditting,
        });
    }

    public onTextNoteInputChange(text: string) {
        this.setState({
            comment: text,
        });
    }

    public onTextNoteInputBlur() {
        const text = safetyHtml(this.state.comment).trim();
        this.syncCommentData({
            comment_id: this.props.draftCommentInfo.comment_id,
            comment: text,
            extend_comment: this.state.extendComment,
            is_editting: this.state.isEditting,
        });
    }

    // 渲染笔记图文创建界面
    public renderTextNoteInput() {
        return (
            <Textarea
                placeholder={this.textareaPlaceholder}
                value={this.state.comment}
                onChange={this.onTextNoteInputChange}
                onBlur={this.onTextNoteInputBlur}
            />
        );
    }

    public renderPicNoteItem(img: IMicrocourseAudioImgArrItem, index: number) {
        const extendComment = this.state.extendComment;

        const itemChecked = +extendComment[index].is_selected === 1;
        const itemContent = extendComment[index].comment;

        const picNoteItemCls = classMapSet({
            'pic-note-item': true,
            'pic-note-selected': itemChecked,
        });
        const noteCls = classMapSet({
            'pic-note-section': true,
            'content-section': true,
            'pic-note-empty': !itemContent,
        });

        return (
            <li className={picNoteItemCls} key={index}>
                <div className="pic-note-section select-section">
                    <MCheckbox
                        isChecked={itemChecked}
                        onChange={(isChecked: boolean) => {
                            this.onNoteItemCheckChange(index, isChecked);
                        }}
                    ></MCheckbox>
                </div>
                <div className="pic-note-section pic-section">
                    <div className="pic-note-thumbnail">
                        <Emg src={ImageUtil.appendWidth(img.imageUrl, 90)} key={index} />
                    </div>
                </div>
                <div
                    className={noteCls}
                    onClick={() => {
                        this.editPicNote(itemContent, img, index);
                    }}
                >
                    <ToggleLine
                        className="pic-note-list-content"
                        maxLine={4}
                        labelOpen={lang('收起')}
                        labelClosed={lang('全文')}
                        expandByBtn={true}
                        theme="2"
                    >
                        {itemContent ? (
                            itemContent
                        ) : (
                            <span className="pic-note-list-placeholder">{lang('点击添加图文笔记...')}</span>
                        )}
                    </ToggleLine>
                </div>
            </li>
        );
    }

    // 在新的窗口中编辑图文笔记的内容
    public editPicNote(itemContent: string, img: IMicrocourseAudioImgArrItem, index: number) {
        this.setState({
            isShowPicNoteContentInput: true,
            picNoteContentIndex: index,
            picNoteContentImg: img.imageUrl,
            picNoteEditContent: itemContent || '', // 如果有则回填，没有则留空
        });
    }

    // 选图及写图文笔记
    public renderPicNoteDashboard() {
        const props = this.props;
        let imgArr = props.imgArr;
        imgArr = imgArr || [];

        return (
            <ul className="pic-note-list">
                {imgArr.map((img: IMicrocourseAudioImgArrItem, index: number) => {
                    {
                        return this.renderPicNoteItem(img, index);
                    }
                })}
            </ul>
        );
    }

    // 完成图文笔记文本的输入，输入了需要自动勾上
    public completePicNoteContentEdit() {
        const newContent = safetyHtml(this.state.picNoteEditContent).trim();
        const extendComment = copyObj(this.state.extendComment as unknown as UnknownObj);
        const index = this.state.picNoteContentIndex;
        // 如果内容有变化才自动选中
        if (extendComment[index].comment !== newContent) {
            extendComment[index].is_selected = 1;
        }
        extendComment[index].comment = newContent;

        this.setState({
            extendComment,
        });

        // 添加延时，防止这个浮层关闭时点击了上个浮层的右上角按钮
        $window.setTimeout(this.closePicNoteContentInput, 500);

        this.syncCommentData({
            comment_id: this.props.draftCommentInfo.comment_id,
            comment: this.state.comment,
            extend_comment: extendComment,
            is_editting: this.state.isEditting,
        });
    }

    public closePicNoteContentInput() {
        this.setState({
            isShowPicNoteContentInput: false,
        });
    }

    public picNoteEditContentChange(value: string) {
        this.setState({
            picNoteEditContent: value,
        });
    }

    public renderPicNoteContentInput() {
        const noteContentHeader = {
            leftProp: {
                label: ' ',
                clsName: 'btn-text',
            },
            centerProp: {
                label: lang('编辑_1'),
                clsName: 'btn-text',
            },
            rightProp: {
                label: lang('完成_SAVE'),
                clsName: 'btn-text',
                callback: this.completePicNoteContentEdit,
            },
        };

        return (
            <div className="pic-note-content-input-wrap">
                <ConfigurableHeader
                    clsName="page-panel-header cover-page-fixed-header pic-note-content-input-header"
                    config={noteContentHeader}
                />
                <div className="pic-note-thumbnail">
                    <Emg src={ImageUtil.appendWidth(this.state.picNoteContentImg, 640)} />
                </div>
                <Textarea
                    className="pic-note-content-input"
                    placeholder={this.picNotePlaceholder}
                    fixKeyboard={true}
                    value={this.state.picNoteEditContent}
                    onChange={this.picNoteEditContentChange}
                />
            </div>
        );
    }

    public renderPanel() {
        if (!this.props.showNoteComposer) {
            return null;
        }

        return (
            <Portal preventBodyScroll={true}>
                <PagePanel
                    clsName={'note-panel-wrap'}
                    title={this.title}
                    leftTitle={this.leftTitle}
                    leftCallback={this.onBack}
                    rightTitle={this.rightTitle}
                    rightCallback={this.onSubmit}
                    leftClsName={'uppercase'}
                    rightClsName={this.state.rightClsName + ' uppercase'}
                >
                    {this.renderNoteContent()}
                </PagePanel>
            </Portal>
        );
    }

    public render() {
        return (
            <div>
                {this.renderPanel()}
                {this.renderPicNoCheckConfirm()}
            </div>
        );
    }
}

export default MicroCourseNoteComposer;
